import React, { useState } from 'react';
import styles from '../../pages/CheckoutPage.module.css';

// Stricter UPI ID regex: local-part@provider
// - Local part: alphanumeric, dot, hyphen, underscore (2–50 chars)
// - Provider: alphanumeric only (2–20 chars)
const UPI_ID_REGEX = /^[a-zA-Z0-9._-]{2,50}@[a-zA-Z0-9]{2,20}$/;

function UpiCollectSection({ amount, processing, onPay }) {
  const [vpa, setVpa] = useState('');
  const [error, setError] = useState('');
  const [touched, setTouched] = useState(false);

  const validate = (value) => {
    const trimmed = (value || vpa).trim();
    if (!trimmed) return 'Please enter your UPI ID.';
    if (!trimmed.includes('@')) return 'UPI ID must contain @  (e.g. name@upi)';
    if (!UPI_ID_REGEX.test(trimmed)) return 'Invalid UPI ID. Example: yourname@okaxis';
    return '';
  };

  const handleChange = (e) => {
    const val = e.target.value.replace(/\s/g, '');
    setVpa(val);
    if (touched) setError(validate(val));
  };

  const handleBlur = () => {
    setTouched(true);
    setError(validate());
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setTouched(true);
    const err = validate();
    if (err) { setError(err); return; }
    onPay({ method: 'upi', vpa: vpa.trim() });
  };

  // Live provider hint
  const provider = vpa.includes('@') ? vpa.split('@')[1] : null;

  return (
    <form onSubmit={handleSubmit} className={styles.collectForm} noValidate>
      <label className={styles.inputLabel} htmlFor="upi-id">
        UPI ID
      </label>
      <input
        id="upi-id"
        type="text"
        className={`${styles.textInput} ${error ? styles.inputError : ''}`}
        placeholder="yourname@okaxis"
        value={vpa}
        onChange={handleChange}
        onBlur={handleBlur}
        autoCapitalize="none"
        autoCorrect="off"
        spellCheck={false}
        inputMode="email"
        disabled={processing}
      />
      {error && <p className={styles.fieldError}>{error}</p>}
      {!error && provider && (
        <p style={{ fontSize: '12px', color: '#4caf50', margin: '4px 0 0' }}>
          ✓ Provider: <strong>{provider}</strong>
        </p>
      )}

      <p className={styles.collectHint}>
        📩 You'll receive a collect request in your UPI app. Approve it to complete payment.
      </p>

      <button
        type="submit"
        className={styles.payBtn}
        disabled={processing || !vpa.trim()}
      >
        {processing ? (
          <><span className={styles.spinnerSmall} /> Sending request…</>
        ) : (
          `Pay ₹${Number(amount).toLocaleString('en-IN')}`
        )}
      </button>
    </form>
  );
}

export default UpiCollectSection;
